import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { Col, Form, FormGroup, Row } from "react-bootstrap";
import moment from "moment";

import Button from "../../../../../components/common/button/Button";
import DatePicker2 from "../../../../../components/common/datepicker/DatePicker2";
import FileInput from "../../../../../components/common/fileInput/FileInput";
import Input from "../../../../../components/common/input/Input";
import RichEditor from "../../../../../components/common/richEditor/RichEditor";
import Select2 from "../../../../../components/common/select/Select2";

import {
  required,
  date,
  floatWithComma,
  comma,
  maxFileSize
} from "../../../../../utils/forms/validators";
import { INVOICE_CREATE_FORM } from "./../../../../../actions/invoice.actions";

import styles from "./InvoiceCreate.scss";

const rateFloat = floatWithComma("Please enter a valid number.");
const rateComma = comma("Please enter numeric characters only");
const dateVal = date("Please enter a valid Date.");
const fileSizeValidation = file => maxFileSize(file, 2);

const richEditorValidation = (max, msg) => value => {
  const valueParse = value
    ? value.replace(/<[^>]*>/g, "").replace("&nbsp;", " ")
    : "";
  return valueParse.length > max && msg;
};

const additionalInformation = richEditorValidation(
  501,
  "Additional Information must be less than or equal to 2500 characters."
);

const validate = values => {
  const errors = {};

  if (
    values.billing_period_start &&
    values.billing_period_end &&
    moment(values.billing_period_end).isBefore(values.billing_period_start)
  ) {
    errors.billing_period_end = `The end date should be after the start date`;
  }

  return errors;
};

class InvoiceCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null
    };

    this.handleStartDateChange = this.handleStartDateChange.bind(this);
  }

  componentDidMount() {
    this.handleStartDateChange(moment());
  }

  handleStartDateChange(value) {
    this.setState({ startDate: moment(value) });
  }

  onSelect = value => {
    this.setState({
      filename: value
    });
  };

  render() {
    const { projects, handleSubmit, submitting, valid } = this.props;

    return (
      <section className={styles.invoice}>
        <div className={styles.content}>
          <h2 className={styles.title}>Submit a New Invoice</h2>

          <Form onSubmit={handleSubmit}>
            <div className={styles.form}>
              <div className={styles.sectionTitle}>Project</div>
              <FormGroup>
                <Field
                  name="project_id"
                  type="select"
                  placeholder="Select Project"
                  component={Select2}
                  options={projects}
                />
              </FormGroup>

              <div className={styles.divider} />
              <div className={styles.sectionTitle}>Amount</div>

              <FormGroup>
                <Field
                  name="amount"
                  type="text"
                  placeholder="Amount"
                  component={Input}
                  onChange={this.handleRateChange}
                  validate={[required, rateFloat, rateComma]}
                />
              </FormGroup>

              <div className={styles.divider} />
              <div className={styles.sectionTitle}>Billing Period</div>

              <Row>
                <Col md={4} xs={12}>
                  <Field
                    name="billing_period_start"
                    placeholder="Start"
                    component={DatePicker2}
                    onSelectDate={this.handleStartDateChange}
                    validate={dateVal}
                  />
                </Col>
                <Col md={4} xs={12}>
                  <Field
                    name="billing_period_end"
                    placeholder="End"
                    component={DatePicker2}
                    minDate={this.state.startDate || moment()}
                    validate={dateVal}
                  />
                </Col>
              </Row>

              <div className={styles.divider} />
              <div className={styles.sectionTitle}>Upload Invoice</div>

              <FormGroup>
                <Field
                  component={FileInput}
                  name="file"
                  placeholder="Select File"
                  accept=".doc,.docx,.pdf"
                  validate={[required, fileSizeValidation]}
                  onSelect={this.onSelect}
                />
              </FormGroup>

              <div className={styles.divider} />
              <div className={styles.sectionTitle}>Additional Information</div>

              <Field
                name="additional_information"
                component={RichEditor}
                placeHolder="Ex., Project ID, Project Code"
                maxLength={501}
                validate={additionalInformation}
              />

              <div className={styles.dividerDouble} />

              <div className={styles.CTAContainer}>
                <Button
                  isPrimary
                  type="submit"
                  size={"large"}
                  noMarginBottom
                  label="Submit Invoice"
                  isDisabled={!valid || submitting}
                />
              </div>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

InvoiceCreate = reduxForm({
  form: INVOICE_CREATE_FORM,
  enableReinitialize: true,
  validate
})(InvoiceCreate);

export default InvoiceCreate;



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/invoice/components/InvoiceCreate.js